import { useEffect } from 'react';
import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

gsap.registerPlugin(DrawSVGPlugin);

const useLineDrawAnimation = (selector = '.line-draw') => {
	useEffect(() => {
		const shapes = `${selector} line, ${selector} react, ${selector} path`;

		const tl = gsap.timeline({ repeat: -1, yoyo: true });

		tl.fromTo(
			shapes,
			{ drawSVG: '0' },
			{ duration: 1, drawSVG: '100%', stagger: 0.1 },
			'-=0.5'
		).to(shapes, { duration: 1, drawSVG: '100%' });

		return () => {
			tl.kill(); // prevent memory leak
		};
	}, [selector]);
};

export default useLineDrawAnimation;
